import { ENV } from '../../config/runtimeEnv';
import { http } from "../../lib/http/client";
const API_BASE_URL = ENV.VITE_LABIQ_SERVER;


export const getSamplesGeneStages = async (SampleID: string) => {
    try {
        const response = await http.get(
            `${API_BASE_URL}/genestage/${SampleID}`
        );
        return response.data.data;
    } catch (error) {
        throw new Error(`Error getting sample deactivaiton date: ${error}`);
    }
};